import { combineReducers } from '@reduxjs/toolkit';
import { reducer as calendarReducer } from 'src/slices/calendar';
import { reducer as projectsBoardReducer } from 'src/slices/projects_board';
import { reducer as mailboxReducer } from 'src/slices/mailbox';
import { reducer as organisationReducer } from 'src/slices/organisation';
import { reducer as autocompleteCacheReducer } from 'src/slices/autocompleteCache';

const rootReducer = combineReducers({
  calendar: calendarReducer,
  projectsBoard: projectsBoardReducer,
  mailbox: mailboxReducer,
  organisation: organisationReducer,
  autocompleteCache: autocompleteCacheReducer
});

export default rootReducer;
